import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { useEffect } from "react";

import { ConnectView } from "../../components/ConnectView/ConnectView";
import { NFTGallery } from "../../components/nft/NFTGallery";
import { useEnrichedWallet } from "../../contexts/enrichedWallet";

export const NFTGalleryView = () => {
  const { trackPageView } = useMatomo();
  const { connected } = useEnrichedWallet();

  useEffect(() => {
    trackPageView({
      documentTitle: "NFT Gallery",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return connected ? <NFTGallery /> : <ConnectView />;
};

export default NFTGalleryView;
